import config from 'config'
import React, { useState, useEffect } from 'react'
import { isEmpty, checkNested } from 'srcReact/helpers/validator'
import { getInitials } from 'srcReact/helpers/utils'
import OrganizationAvatar from 'srcReact/components/common/OrganizationAvatar'
import OrganizationSideBar from 'srcReact/components/navigation/OrganizationSideBar'
import { hasNotifications } from 'srcReact/helpers/organizationHelper'
import { canCreateGroup } from 'srcReact/helpers/userHelper'
import Icon from 'srcReact/components/icons/Icon'
import {
  isWorkplaceManagerOfMany,
  isWorkplaceManagerOfOne,
  isWorkplaceManagerOfAtLeastOne
} from 'srcReact/helpers/userHelper'
import styles from './styles.module.scss'
import LogoutPopin from 'srcReact/components/popinsContent/LogoutPopin'
import { loginActions as la } from 'srcReact/LoginPage'
import { useDispatch } from 'react-redux'
import history, { redirectToPage } from 'srcReact/helpers/history'
import Spinner from 'srcReact/components/common2/Spinner'
import GroupsMixrsList from './components/GroupsMixrsList'
import ConversationsList from './components/ConversationsList'
import { appConstantSettings } from 'srcReact/appConstantSettings'

export default function AuthorizedSideMenu(props) {
  const {
    t,
    user,
    sidebar,
    current_organization,
    orgaSideBarOpened,
    organization_list,
    clickAction,
    switchOrganization,
    toggleOrgaSideBar,
    closeOrgaSideBar,
    conversations,
    groups_mixrs,
    isOpen,
    user_properties,
    notificationCount
  } = props

  const dispatch = useDispatch()
  const [showLogoutPopup, setShowLogoutPopup] = useState(false)
  const [activeMenu, setActiveMenu] = useState('user')
  const [showAllGroupsMixrs, setShowAllGroupsMixrs] = useState(false)
  const [showAllConversations, setShowAllConversations] = useState(false)
  useEffect(() => {
    if (!isOpen) {
      setShowAllGroupsMixrs(false)
      setShowAllConversations(false)
    }
  }, [isOpen])

  const handlePopup = () => {
    clickAction()
    setShowLogoutPopup(true)
  }

  const getWorkplacesUrl = () => {
    if (checkNested(current_organization, 'info', 'my_access', 'role_as_workplace_member')) {
      return `${config.webUrl}/0/workplace/settings/${current_organization.info.my_access.role_as_workplace_member.workplace_list[0]}`
    }
  }

  const redirectToDashboard = (data) => {
    const { workplace_id, group_id } = data
    if (workplace_id && workplace_id > 0) {
      history.push(`/0/dashboard/workplace/${workplace_id}`)
    } else if (group_id && group_id > 0) {
      history.push(`/0/dashboard/group/${group_id}`)
    }
  }

  const handleBottomToggle = (active) => {
    setActiveMenu(active)
  }
  const hanldeNavigation = (url) => {
    clickAction()
    redirectToPage(url)
  }
  const isUserMenu = activeMenu === 'user'
  const isSettingsMenu = activeMenu === 'settings'
  // const unreadConversationsList =
  //   (conversations.length >= 1 && conversations.filter((c) => c.conversation.userUnreadMessageCount > 0)) || []
  const groupsMixrs = showAllGroupsMixrs
    ? [...groups_mixrs]
    : [...groups_mixrs].slice(0, appConstantSettings.SIDEBAR_LIST_QTY)
  const isShowAllGroupsMixrs = [...groups_mixrs].length > appConstantSettings.SIDEBAR_LIST_QTY
  let conversationsListData = []
  let isShowAllConversations = false
  // if (unreadConversationsList.length >= 1) {
  //   conversationsListData = showAllConversations ? unreadConversationsList : unreadConversationsList.slice(0, 5)
  //   isShowAllConversations = unreadConversationsList.length > 5
  // } else {
  conversationsListData = showAllConversations
    ? conversations
    : conversations.slice(0, appConstantSettings.SIDEBAR_LIST_QTY)
  isShowAllConversations = conversations.length > appConstantSettings.SIDEBAR_LIST_QTY
  // }

  return (
    <div className={styles.sidebarHeaderWrapper}>
      <div className={styles.orgData}>
        <button className={styles.menuButton} onClick={clickAction}>
          <Icon name='menu' size='large40' styleModifier={styles.menuIcon} />
        </button>
        {!isEmpty(current_organization.info) && (
          <React.Fragment>
            <span className={styles.orgDataName}>{current_organization.info.name}</span>
            <div className={styles.organizationAvatar}>
              <OrganizationAvatar
                color={current_organization.info.color || appConstantSettings.DEFAULT_COLOR.name}
                hideSubTitle={true}
                onClick={toggleOrgaSideBar}
                hideNumberNotification={false} //{!hasNotifications(organization_list.items, current_organization)}
                title={current_organization.info.accronym || getInitials(current_organization.info.name)}
                fullOrgName={current_organization?.info?.name}
                notificationNumber={notificationCount}
              />
              {orgaSideBarOpened && (
                <OrganizationSideBar
                  currentOrganization={current_organization.info}
                  organizations={organization_list.items}
                  organizationAction={switchOrganization}
                  close={closeOrgaSideBar}
                  isMobile={true}
                  user_properties={user_properties}
                />
              )}
            </div>
          </React.Fragment>
        )}
      </div>

      <div className={styles.profile}>
        <div className={styles.profileBox} onClick={() => hanldeNavigation(`${'/0/profile/'}${user.id}`)}>
          <img className={styles.profilePicture} src={user.profile_picture} alt={''} />
          <span className={styles.profileName}>
            {user.meta ? user.meta.firstname + ' ' + user.meta.lastname : user.firstname + ' ' + user.lastname}
          </span>
        </div>
      </div>

      {isSettingsMenu ? (
        <React.Fragment>
          {current_organization && current_organization.updating ? (
            <a className={`${styles.menuItem} ${styles.menuItemLoader}`}>
              <Spinner />
            </a>
          ) : (
            <React.Fragment>
              <a className={styles.menuItem} href={config.webUrl + '/0/member-directory'}>
                <Icon
                  name='member-directory'
                  size='large24'
                  alt='member-directory'
                  styleModifier={styles.marginRight1}
                />
                <span>{t('nav.member_directory')}</span>
              </a>
              {!isEmpty(current_organization.info) && (
                <a className={styles.menuItem} href={getWorkplacesUrl()}>
                  <Icon name='workplaces' size='large24' styleModifier={styles.marginRight1} />
                  <span>{t('nav.mobile.workplaces')}</span>
                </a>
              )}
              {isWorkplaceManagerOfOne(current_organization) &&
                !!user_properties?.workplace?.with_member_invitation && (
                  <a
                    className={styles.menuItem}
                    href={
                      config.webUrl +
                      '/0/workplace/new-invites/' +
                      current_organization.info.my_access.role_as_workplace_manager.workplace_list[0]
                    }>
                    <Icon name='add-contact' size='large24' styleModifier={styles.marginRight1} />
                    <span>{t('nav.invite')}</span>
                  </a>
                )}
              <a className={styles.menuItem} href={config.webUrl + '/0/your-invites'}>
                <Icon name='mail-opened' size='large24' styleModifier={styles.marginRight1} />
                <span>{t('nav.mobile.my_invites')}</span>
              </a>
              {isWorkplaceManagerOfAtLeastOne(current_organization) && (
                <a className={styles.menuItem} href={config.webUrl + '/0/moderation?tab=workplace_activity'}>
                  <Icon name='flag-icon' size='large24' styleModifier={styles.marginRight1} />
                  <span>{t('nav.moderationCenter')}</span>
                </a>
              )}
              <a className={styles.menuItem} href={config.webUrl + '/0/settings/account'}>
                <Icon name='setting' size='large24' styleModifier={styles.marginRight1} />
                <span>{t('nav.mobile.settings')}</span>
              </a>
              <a className={styles.menuItem} href='https://mixr-knowledge-base.mixr.net/'>
                <Icon name='help' size='large24' styleModifier={styles.marginRight1} />
                <span>{t('nav.help')}</span>
              </a>
              {current_organization.info && current_organization.info.editable === true ? (
                <a className={styles.menuItem} href={config.webUrl + '/0/organization/settings'}>
                  <Icon
                    name='organization'
                    size='large24'
                    alt={t('nav.orgaSettings')}
                    styleModifier={styles.marginRight1}
                  />
                  <span>{t('nav.orgaSettings')}</span>
                </a>
              ) : null}
            </React.Fragment>
          )}
          <a className={`${styles.menuItem} ${styles.menuItemLast}`} onClick={handlePopup}>
            <Icon name='logout' size='large24' styleModifier={styles.marginRight1} />
            <span>{t('nav.mobile.signout')}</span>
          </a>
          {showLogoutPopup && (
            <LogoutPopin
              showLogout={showLogoutPopup}
              closeLogout={() => setShowLogoutPopup(false)}
              handleClick={() => dispatch(la.userLogout())}
            />
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className={styles.quickLinkWrapper}>
            <div className={styles.quickLinkItem} onClick={() => hanldeNavigation('/0/feed')}>
              <img
                src={`${config.assetUrl + '/images/feed-icon.svg'}`}
                alt={t('sidebar.feed')}
                className={styles.marginBottom1}
              />
              <span className={styles.quickLinkText}>{t('nav.feed')}</span>
            </div>
            <div className={styles.quickLinkItem} onClick={() => hanldeNavigation('/0/myhome')}>
              <img
                src={`${config.assetUrl + '/images/myHome-colored.svg'}`}
                alt={t('sidebar.home')}
                className={styles.marginBottom1}
              />
              <span className={styles.quickLinkText}>{t('nav.my_home')}</span>
            </div>
            <div className={styles.quickLinkItem} onClick={() => hanldeNavigation('/0/discover')}>
              <img
                src={`${config.assetUrl + '/images/discover-coloured.svg'}`}
                alt={t('sidebar.discover')}
                className={styles.marginBottom1}
              />
              <span className={styles.quickLinkText}>{t('nav.discover')}</span>
            </div>
            {/* {sidebar?.dashboard?.group_id > 0 || sidebar?.dashboard?.workplace_id > 0 ? (
              <div className={styles.quickLinkItem} onClick={() => redirectToDashboard(sidebar.dashboard)}>
                <img
                  src={`${config.assetUrl + '/images/dashboards-icon.svg'}`}
                  alt={t('sidebar.dashboard')}
                  className={styles.marginBottom1}
                />
                <span className={styles.quickLinkText}>{t('nav.dashboard')}</span>
              </div>
            ) : ( */}
            <div className={styles.quickLinkItem} onClick={() => hanldeNavigation('/0/calendar')}>
              <img
                src={`${config.assetUrl + '/images/calendar-colored.svg'}`}
                alt={t('sidebar.calendar')}
                className={styles.marginBottom1}
              />
              <span className={styles.quickLinkText}>{t('nav.calendar')}</span>
            </div>
            {/* )} */}
          </div>
          {groupsMixrs.length >= 1 && (
            <div className={styles.groupsMixrs}>
              <div className={styles.name}>{t('nav.mobile.groupsMixrs')}</div>
              {groupsMixrs.map((item, idx) => (
                <GroupsMixrsList key={idx} {...item} closeMenu={clickAction} />
              ))}
              {!showAllGroupsMixrs && isShowAllGroupsMixrs && (
                <div
                  className={styles.showAll}
                  role='button'
                  onClick={() => setShowAllGroupsMixrs(!showAllGroupsMixrs)}>
                  {t('nav.mobile.showAll')}
                </div>
              )}
            </div>
          )}
          {conversationsListData.length >= 1 && (
            <div className={styles.conversations}>
              <div className={styles.name}>{t('messenger.chats')}</div>
              {conversationsListData.map((c, idx) => (
                <ConversationsList conversation={c} key={idx} closeMenu={clickAction} />
              ))}
              {!showAllConversations && isShowAllConversations && (
                <div
                  className={styles.showAll}
                  role='button'
                  onClick={() => setShowAllConversations(!showAllConversations)}>
                  {t('nav.mobile.showAll')}
                </div>
              )}
            </div>
          )}
        </React.Fragment>
      )}

      <div className={styles.bottomToggle}>
        <div className={styles.bottomIcons}>
          <div className={styles.iconStyle} role='button' onClick={() => handleBottomToggle('user')}>
            <Icon name='contact' size='large32' styleModifier={isUserMenu ? styles.isActive : ''} />
            {isUserMenu && <div className={styles.activeLine} />}
          </div>
          <div className={styles.iconStyle} role='button' onClick={() => handleBottomToggle('settings')}>
            <Icon name='setting' size='large32' styleModifier={isSettingsMenu ? styles.isActive : ''} />
            {isSettingsMenu && <div className={styles.activeLine} />}
          </div>
        </div>
      </div>
    </div>
  )
}
